export default {
  addOns: 'Tillägg',
  all: 'Alla',
  browse: 'Bläddra',
  buyTickets: 'Köp biljetter',
  countSelected: '{{count}} valda',
  joinWaitlist: 'Ställ dig i kö',
  joining: 'Ansluter',
  salesEnded: 'Försäljningen avslutad',
  schedule: 'Schema',
  soldOut: 'Slutsåld',
  tickets: 'Biljetter',
  noDatesAvailable: 'Inga datum tillgängliga',
  seeMoreDates: 'Se fler datum',
  about: 'Om',
  agenda: 'Agenda',
  menu: 'Meny',
  included: 'Inkluderat',
  viewMore: 'Visa mer',
  viewLess: 'Visa mindre',
  location: 'Plats',
  time: 'Tid',
  at: 'kl',
  noTimesAvailableOnThisDateFotThisPartySize:
    'Inga tillgängliga tider på detta datum för denna gruppstorlek',
  availableTimes: 'Tillgängliga tider',
  waitlist: 'Väntelista',
  continue: 'Fortsätt',
  ticketsAreNoLongerAvailable: 'Biljetter är inte längre tillgängliga.',
  checkOutOutOtherExperiences: 'Kolla in våra andra upplevelser!',
  viewExperiences: 'Visa upplevelser',
  from: 'från',
  cancellationPolicy: 'Avbokningspolicy',
  rsvp: 'RSVP',
  nights: 'nätter',
  request: 'Förfrågan',
  arrival: 'Ankomst',
  departure: 'Avresa',
};
